module.exports = __webpack_public_path__ + "static/media/liwentao.d02cf9db.png";